export default __webpack_public_path__ + "static/media/ng.04faf549.svg";